import { type RecordId } from './shared-types';

type RecordType = Partial<{
  id: RecordId | number | string;
  type: string;
}>;

export async function createRecordLink(
  childRecord: RecordType,
  parentRecord: RecordType,
  linkType: string = '80' // Research
) {
  const response = await fetch('/record_links.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.csrfToken(),
    },
    body: JSON.stringify({
      record_id: parentRecord.id,
      record_type: parentRecord.type,
      record_link: {
        record_type: childRecord.type,
        record_ids: [childRecord.id],
        link_type: linkType,
      },
    }),
  });

  return response.json();
}
